__webpack_require__.p = "/tedxnsysu/";